import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, ExcluirLocalidadesRelacionadasRequest } from './types';

export function excluirLocalidadesRelacionadasRequest(
	token: string,
	data: ExcluirLocalidadesRelacionadasRequest,
): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_LOCALIDADES_RELACIONADAS,
		token,
		payload: data,
	};
}
export function excluirLocalidadesRelacionadasSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_LOCALIDADES_RELACIONADAS_SUCCESS,
		payload,
	};
}
export function excluirLocalidadesRelacionadasFailure(): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_LOCALIDADES_RELACIONADAS_FAILURE,
		payload: null,
	};
}
export function excluirLocalidadesRelacionadasClear(): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_LOCALIDADES_RELACIONADAS_CLEAR,
		payload: null,
	};
}
